const Completed = () => {

    return (
        <main className="container text-center mb-5">

            <div className="row">
                <div className="col-12  col-md-8 mx-auto">
                    { /* Card Component */}
                    <div className="card">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-12 p-2">
                                    <img src="/brand.png" alt="brand" className="brand" />
                                </div>
                                <hr />
                                <div className="col-12 fw-bold">
                                    <p>Unit Costs Claim Form saved. To view your previously saved travel expenses claims, follow this <a href="/me/claims">link</a>.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </main>
    );

}
export default Completed;